import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, reset } from 'redux-form';
import RaisedButton from 'material-ui/RaisedButton';
import moment from 'moment';

import { renderCheckBox, isValidNameWithSpace, renderDateField, renderAutoCompleteMultipleSelection, renderTextField } from '../../../../components/reduxFields';
import { getDataAnalytics } from './actions/dataAnalyticsActions';
import { base64Decode } from '../../../../actions/utilAction';
import { getPatientBehaviorsReductionByPatientId } from '../../../scheduling/components/SessionNotes_EBS/actions/soapActions';
import AnalyticsDataComponent from './analyticsDataComponent';
import validate from './validate';

class DataAnalyticsBehaviors extends Component {

    constructor(props) {
        super(props);
        this.state = {
            FromDate: new Date(new Date().setDate(new Date().getDate() - 7)),
            ToDate: new Date(),
            patientId: props.match.params.id ? base64Decode(props.match.params.id) : 0,            
            masterPatientBehaviorsReductions: '',
            showGraph: '',
            xAxisName: null,
            yAxisName: null,
            disableYaxislabel: true,
            disableXaxislabel: true,
            selectedBehaviorsReduction: '',
        }
    }

    componentWillMount = () => {
        this.props.getPatientBehaviorsReductionByPatientId(this.state.patientId);
    }

    onDateChange = (input, value) => {
        input.onChange(moment(value).format());
        this.setState({ [input.name]: value });
    }

    dataAnalyticsSubmit = (event) => {
        let patientId = this.state.patientId;
        let behaviorsReductionId = event.behaviorsReductionId;
        if (patientId && behaviorsReductionId) {
            this.setState({
                showGraph: true,
                xAxisName: event.XAxisName,
                yAxisName: event.YAxisName,
                disableYaxislabel: event.disableYaxislabel === undefined ? this.state.disableYaxislabel : !event.disableYaxislabel,
                disableXaxislabel: event.disableXaxislabel === undefined ? this.state.disableXaxislabel : !event.disableXaxislabel
            });
        }
        let FromDate = event.FromDate ? moment(event.FromDate).format('YYYY-MM-DD') : moment(this.state.FromDate).format('YYYY-MM-DD');
        let ToDate = event.ToDate ? moment(event.ToDate).format('YYYY-MM-DD') : moment(this.state.ToDate).format('YYYY-MM-DD');
        // this.setState({
        //     FromDate: FromDate,
        //     ToDate: ToDate
        // })
        this.props.getDataAnalytics(patientId, behaviorsReductionId, FromDate, ToDate);
    }

    handleReset = () => {
        this.props.dispatch(reset('DataAnalyticsBehaviorsForm'));
        this.setState({
            FromDate: new Date(new Date().setDate(new Date().getDate() - 7)),
            ToDate: new Date(),
            showGraph: ''
        })
    }

    handleNewRequestMultiSelect = (input, selectedValues) => {
        input.onChange(selectedValues);
        this.setState({
            showGraph: '',
            selectedBehaviorsReduction: selectedValues.label,
        })

    }

    render() {
        const { handleSubmit } = this.props;
        return (
            <div>
                <h2 className="page_title">Behavior Graphs</h2>
                <div className="clearfix"></div>
                <div className="readmin-panel">
                    <div className="panel-body">
                        <form className="readmin-form custom_form" onSubmit={handleSubmit(this.dataAnalyticsSubmit)}>
                            <div className='row'>                                
                                <div className="col-sm-12 mt-10 require">
                                    <Field
                                        name='behaviorsReductionId'
                                        label="Behavior Name"
                                        options={this.props.masterPatientBehaviorsReductions}
                                        handleNewRequest={this.handleNewRequestMultiSelect}
                                        component={renderAutoCompleteMultipleSelection}
                                    />
                                </div>
                                <div className="col-sm-6 mt-10">
                                    <Field
                                        name="FromDate"
                                        placeholder="From Date"
                                        locale="en-US"
                                        selected={this.state.FromDate}
                                        onDateChange={this.onDateChange}
                                        openToYearSelection={true}
                                        component={renderDateField} />
                                </div>
                                <div className="col-sm-6 mt-10">
                                    <Field
                                        name="ToDate"
                                        placeholder="To Date"
                                        locale="en-US"
                                        minDate={this.state.FromDate}
                                        selected={this.state.ToDate}
                                        openToYearSelection={true}
                                        onDateChange={this.onDateChange}
                                        component={renderDateField} />
                                </div>
                                <div className="col-sm-6 mt-10">
                                    <Field
                                        name="XAxisName"
                                        type="text"
                                        maxLength="250"
                                        label="X-Axis Name"
                                        normalize={isValidNameWithSpace}
                                        component={renderTextField}
                                    />
                                </div>
                                <div className="col-sm-6 mt-10">
                                    <Field
                                        name="YAxisName"
                                        type="text"
                                        maxLength="250"
                                        label="Y-Axis Name"
                                        normalize={isValidNameWithSpace}
                                        component={renderTextField}
                                    />
                                </div>
                                 <div className="col-sm-6 mt-10">
                                    <Field 
                                        className="mt20 mb0" 
                                        name="disableXaxislabel" 
                                        label="Disable X Axis Label"
                                        component={renderCheckBox} />
                                </div>
                                <div className="col-sm-6 mt-10">
                                    <Field 
                                        className="mt20 mb0" 
                                        name="disableYaxislabel" 
                                        label="Disable Y Axis Label"
                                        component={renderCheckBox} />
                                </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-12 btn_rt reset-btn claims_filter mt-20">
                                <RaisedButton className="grey_btn" type="Submit" primary={true}>Generate Graph</RaisedButton>
                                <RaisedButton className="grey_btn ml_15" onTouchTap={this.handleReset}>Reset</RaisedButton>
                            </div>
                        </form>
                    </div>
                    {this.state.showGraph !== '' && <div className='row'>
                        {
                            this.props.dataAnalytics.loading === true
                                ?
                                <div className="col-sm-12 text-center no-record" >Loading...</div>
                                :
                                <AnalyticsDataComponent 
                                FromDate={this.state.FromDate}
                                ToDate={this.state.ToDate} 
                                xAxisName={this.state.yAxisName}
                                yAxisName={this.state.xAxisName}
                                disableYaxislabel={this.state.disableYaxislabel}
                                disableXaxislabel={this.state.disableXaxislabel}
                                selectedBehaviorsReduction={this.state.selectedBehaviorsReduction}
                                />
                        }
                    </div>}
                </div>
            </div>
        )
    }
}

DataAnalyticsBehaviors = reduxForm({
    form: 'DataAnalyticsBehaviorsForm',
    validate,
    enableReinitialize: true,
})(DataAnalyticsBehaviors);

function mapStateToProps(state) {
    let masterPatientBehaviorsReductions = [];
    
    if (state.soap.behaviorsReductionsData) {
        masterPatientBehaviorsReductions = state.soap.behaviorsReductionsData.data.PatientBehaviorsReduction || [];        
    }
    return {
        loading: state.patient.loading || state.patient.loadingMasterData,
        masterPatientBehaviorsReductions: masterPatientBehaviorsReductions,        
        dataAnalytics: state.dataAnalytics
    };
}

export default connect(mapStateToProps, { getPatientBehaviorsReductionByPatientId, getDataAnalytics })(DataAnalyticsBehaviors);



// WEBPACK FOOTER //
// ./src/modules/patients/components/DataAnalyticsBehaviors/index.js